import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import BarChartIcon from "@material-ui/icons/BarChart";
import LayersIcon from "@material-ui/icons/Layers";
import AssignmentIcon from "@material-ui/icons/Assignment";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";

export const mainListItems = (
    <div>
        <Link
            style={{ textDecoration: "none", color: "rgba(0, 0, 0)" }}
            to="/admindashboard"
        >
            <ListItem button>
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Overview" />
            </ListItem>
        </Link>

        <Link
            style={{ textDecoration: "none", color: "rgba(0, 0, 0)" }}
            to="/manage-users"
        >
            <ListItem button>
                <ListItemIcon>
                    <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Manage Users" />
            </ListItem>
        </Link>

        <Link
            style={{ textDecoration: "none", color: "rgba(0, 0, 0)" }}
            to="/manage-videos"
        >
            <ListItem button>
                <ListItemIcon>
                    <VideoLibraryIcon />
                </ListItemIcon>
                <ListItemText primary="Manage Videos" />
            </ListItem>
        </Link>

        <ListItem button>
            <ListItemIcon>
                <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Reports" />
        </ListItem>
        <ListItem button>
            <ListItemIcon>
                <LayersIcon />
            </ListItemIcon>
            <ListItemText primary="Integrations" />
        </ListItem>
    </div>
);
